import { Injectable } from '@angular/core';
import { Headers, Http, Response } from '@angular/http';
//TODO: check if use jwt or other
//import { tokenNotExpired } from 'angular2-jwt';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/do';
import {Enterprise} from '../models/enterprise';

@Injectable()
export class SignupService {

  idToken: string;
  user: any;

  constructor(private http: Http) {
    this.idToken = localStorage.getItem('id_token');
    this.user = JSON.parse(localStorage.getItem('name'));
  }

  public signup(enterprise:Enterprise): Observable<any> {
    const url = `${ environment.apiRoot }/signup/`;
    const body = enterprise;

    const headers = new Headers({
      'Content-Type': 'application/json',
      'X-API-KEY': environment.apiKey
    });

    return this.http.post(url, body, { headers: headers })
      .map((response: Response) => response.json())
      .do((json: any) => this.saveToken(json))
      .catch((error:any) => Observable.throw(error.json().meta || {message:'server error', status:0}));
  }

  public authenticated() {
    return this.idToken !== null;
    //TODO: check if token has expired
    //return tokenNotExpired('id_token', this.idToken);
  }

  //noinspection JSMethodCanBeStatic
  private saveToken(res) {
    if(res && res.meta) {
      if(res.meta.status === 200) {
        this.idToken = res.data.id;
        this.user = res.data;
        localStorage.setItem('id_token', this.user.id);
        localStorage.setItem('user', JSON.stringify(this.user));
      }
    }
  }

  //noinspection JSMethodCanBeStatic
  public logout(): void {
    localStorage.removeItem('id_token');
    localStorage.removeItem('user');
    localStorage.removeItem('premium');
    this.idToken = null;
    this.user = null;
  }
}



// WEBPACK FOOTER //
// /var/www/_deploy/front-company-testing/2018-09-30-21-57-10/src/app/services/signup.service.ts